import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import apiClient from '@/services/api-client';
import { ApiResponse, CountryItem, CountryState } from '@/services/types';
import { API_ENDPOINTS } from '@/utils/constants/end-points';

// ---------------------------
//  ASYNC THUNKS
// ---------------------------

// GET LIST
export const fetchCountries = createAsyncThunk<CountryItem[]>(
  'country/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get<ApiResponse<CountryItem[]>>(
        `${API_ENDPOINTS.ONBOARDING}/countries`
      );
      return res.data.data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

// ---------------------------
//  SLICE
// ---------------------------

const initialState: CountryState = {
  data: [],
  loading: false,
  error: null,
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH
    builder.addCase(fetchCountries.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchCountries.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCountries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default countrySlice.reducer;
